import React from 'react';
import { Briefcase, Code2, Home, Mail, User } from 'lucide-react';
import { Section } from '../types';

interface MobileNavProps {
  activeSection: Section;
  onSectionChange: (section: Section) => void;
}

const MobileNav: React.FC<MobileNavProps> = ({ activeSection, onSectionChange }) => {
  return (
    <nav
      style={{ bottom: 'calc(1.5rem + env(safe-area-inset-bottom))' }}
      className="md:hidden fixed left-1/2 -translate-x-1/2 flex items-center bg-zinc-950/90 backdrop-blur-3xl px-6 py-4 rounded-full border border-white/10 z-[100] shadow-2xl space-x-6 sm:space-x-10"
    >
      <button onClick={() => onSectionChange(Section.Home)} className={activeSection === Section.Home ? 'text-red-500 scale-110' : 'text-zinc-500'}>
        <Home className="w-5 h-5 transition-transform" />
      </button>
      <button onClick={() => onSectionChange(Section.Work)} className={activeSection === Section.Work ? 'text-red-500 scale-110' : 'text-zinc-500'}>
        <Briefcase className="w-5 h-5 transition-transform" />
      </button>
      <button onClick={() => onSectionChange(Section.Skills)} className={activeSection === Section.Skills ? 'text-red-500 scale-110' : 'text-zinc-500'}>
        <Code2 className="w-5 h-5 transition-transform" />
      </button>
      <button onClick={() => onSectionChange(Section.About)} className={activeSection === Section.About ? 'text-red-500 scale-110' : 'text-zinc-500'}>
        <User className="w-5 h-5 transition-transform" />
      </button>
      <button onClick={() => onSectionChange(Section.Contact)} className={activeSection === Section.Contact ? 'text-red-500 scale-110' : 'text-zinc-500'}>
        <Mail className="w-5 h-5 transition-transform" />
      </button>
    </nav>
  );
};

export default MobileNav;
